import apiRequest from 'utils/api/apiRequest';
import * as URLS from './urls';

export const monitorApi = {
  loadList: () => apiRequest(URLS.MONITOR_LIST),
  addRegnosToMonitor: data => apiRequest(URLS.ADD_TO_MONITOR, { method: 'post', data }),
  addFileToMonitor: (data, id, del) => {
    const options = {
      method: 'post',
      formData: true,
      data
    };
    return apiRequest(`${URLS.ADD_FILE_TO_MONITOR}/${id}/${del}`, options);
  },
  loadStatistics: monitor => apiRequest(URLS.STATISTICS + `/${monitor}`),
  loadWatchlist: monitor => apiRequest(`${URLS.WATCHLIST}/${monitor}`),
  loadMonitorOverview: monitor => apiRequest(`${URLS.MONITOR_OVERVIEW}/${monitor}`),
  removeFromWatchlist: (monitor, regno) =>
    apiRequest(`${URLS.REMOVE_WATCHLIST}/${monitor}/${regno}`, { method: 'delete' })
};
